module.exports = __webpack_public_path__ + "img/header-image.2ff6bf0e.jpg";